
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentCareersArt: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getCareersArt({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Careers/GetCareersArt`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_CAREERS_ARTS', response.data.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateCareersArt({ commit },dataToSend) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Careers/UpdateCareersArt`,dataToSend);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async getCareersFields({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Careers//GetFormFieldsText`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_CAREERS_FIELDS', response.data.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateCareersFields({ commit },dataToSend) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Careers/UpdateFormFieldText`,dataToSend);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    
    async setCareersFields({ commit }, careersFields) {
        try {
            await commit('SET_CAREERS_FIELDS', careersFields);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentCareersFieldToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_CAREERS_FIELD',partner);
        await commit('axiosSuccess');
        return true
    },
    
    
    async setCareersArt({ commit }, careersArt) {
        try {
            await commit('SET_CAREERS_ARTS', careersArt);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentCareersArtToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_CAREERS_ART',partner);
        await commit('axiosSuccess');
        return true
    },
    
    

    //HOME DEPARTMENTS
    async getAllDepartments({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Careers/GetDepartmentsList`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_DEPARTMENTS', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    

  
    async deleteDepartment({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Careers/DeleteDepartment`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

   


    async addDepartment({ commit }, department) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Careers/AddDepartment`, department);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateDepartment({ commit }, department) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Careers/UpdateDepartment`, department);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async setDepartments({ commit }, departments) {
        try {
            await commit('SET_DEPARTMENTS', departments);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentDepartmentToView({ commit },department) {
        await commit('axiosStart');
        await commit('SET_CURRENT_DEPARTMENT',department);
        await commit('axiosSuccess');
        return true
    },


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
